import ApiService from "@/services/api.service"

/// *** Billing Service *** ///

export const BillingService = {
  getTariffInfo() {
    return ApiService.get(`clinic/tariff`)
  },
  payImitation() {
    return ApiService.post(`clinic/tariff/pay`)
  },
  pay(params) {
    return ApiService.post(`clinic/tariff/pay/init`, params)
  },
  paymentStatus(payment_id, superadmin = false) {
    return ApiService.get(`${superadmin ? 'superadmin/' : ''}clinic/tariff/pay/status/${payment_id}`)
  },
  paymentStatusOnly(payment_id, superadmin = false) {
    return ApiService.get(`${superadmin ? 'superadmin/' : ''}clinic/tariff/pay/status/${payment_id}/check`, {}, { loader: false })
  },
  unblockTemporarily() {
    return ApiService.post(`clinic/tariff/unblock/temporary`)
  },
  refundPay(payment_id) {
    return ApiService.post(`superadmin/clinic/tariff/pay/refund/${payment_id}`)
  },
  changeTariff(tariff_id) {
    return ApiService.post(`clinic/tariff/change`, { tariff_id: tariff_id })
  },
  togglePaymentConfirm(payment_id) {
    return ApiService.post(`superadmin/clinic/tariff/pay/confirm/${payment_id}/toggle`)
  },
}
